<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
        v-row(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="showModal = !showModal" height)
              v-icon(color="basic800" :size="24") mdi-close
          v-col.ml-3
            .h6.basic800--text(v-if="(agent && agent.bank) || (member && member.bank)") {{ $t('update_bank') }}
            .h6.basic800--text(v-else) {{ $t('add_bank') }}

      v-card-text.pa-0
        v-form(ref="form")
          v-card.pa-4
            .bank-id
              p.mb-2.label.basic600--text.text-uppercase.mt-2 {{ $t('select_bank') }}
              v-select.mt-2.p1(v-model="bank" solo flat outlined dense hide-details height="40" item-value="code" :placeholder="$t('bank_name.label')" :items="banks" item-text="name" :rules="rules.has_quantity" background-color="basic200")
                template(v-slot:selection="data")
                  v-row(align="center")
                    v-col.py-0.shrink
                      v-avatar(size="20")
                        v-img(:src="data.item.image")
                    v-col.py-0
                      p.mb-0 {{ data.item.name }}
                template(v-slot:item="data")
                  v-row(align="center")
                    v-col.py-2.shrink
                      v-avatar(size="40")
                        v-img(:src="data.item.image")
                    v-col.py-2
                      p.mb-0 {{ data.item.name }}

            .account-number
              p.mb-2.mt-4.label.basic600--text.text-uppercase.mt-2 {{ $t('bank_account_number') }}
              v-text-field.mt-2.p1(solo flat outlined dense persistent-hint hide-details height="40" v-model="bankAccounut" :placeholder="$t('account_num.placeholder')" :rules="rules.not_empty" background-color="basic200")

            .account-name
              p.mb-2.mt-4.label.basic600--text.text-uppercase.mt-2 {{ $t('bank_account_owner') }}
              v-text-field.mt-2.p1(solo flat outlined dense persistent-hint hide-details height="40" v-model="accountName" :placeholder="$t('account_name.placeholder')" :rules="rules.not_empty" background-color="basic200")

      v-card-actions
        v-spacer
        v-btn.button-Aa-small(color='grey', text @click='showModal = false')
          | {{ $t('cancel') }}
        v-btn.mr-2.button-AA-medium(color='info500' depressed height=32 :loading="isLoading" @click='clickSave')
          div.basic100--text(v-if="bank") {{ $t('update') }}
          div.basic100--text(v-else) {{ $t('add') }}

</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AddAgentBankAccount',
  props: ['open', 'company', 'agent'],
  data: () => ({
    bank: null,
    bankAccounut: null,
    accountName: null,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'Item is required', (v) => v != 0|| 'Item is required']
    },
    banks: [
      { code: 'MBBEMYKL', name: 'Maybank', image: require('@/assets/images/fpx/MBB0228.png') },
      { code: 'CIBBMYKL', name: 'CIMB', image: require('@/assets/images/fpx/BCBB0235.png') },
      { code: 'PBBEMYKL', name: 'Public Bank', image: require('@/assets/images/fpx/PBB0233.png') },
      { code: 'RHBBMYKL', name: 'RHB Bank', image: require('@/assets/images/fpx/RHB0218.png') },
      { code: 'HLBBMYKL', name: 'Hong Leong Bank', image: require('@/assets/images/fpx/HLB0224.png') },
      { code: 'ARBKMYKL', name: 'AmBank', image: require('@/assets/images/fpx/AMBB0209.png') },
      { code: 'BIMBMYKL', name: 'Bank Islam Malaysia', image: require('@/assets/images/fpx/BIMB0340.png') },
      { code: 'PHBMMYKL', name: 'Affin Bank', image: require('@/assets/images/fpx/ABB0233.png') },
      { code: 'MFBBMYKL', name: 'Alliance Bank Malaysia', image: require('@/assets/images/fpx/ABMB0212.png') },
      { code: 'BKRMMYKL', name: 'Bank Rakyat', image: require('@/assets/images/fpx/BKRM0602.png') },
      { code: 'BMMBMYKL', name: 'Bank Muamalat Malaysia', image: require('@/assets/images/fpx/BMMB0341.png') },
      { code: 'BSNAMYK1', name: 'Bank Simpanan Nasional', image: require('@/assets/images/fpx/BSN0601.png') },
      { code: 'HBMBMYKL', name: 'HSBC', image: require('@/assets/images/fpx/HSBC0223.png') },
      { code: 'KFHOMYKL', name: 'Kuwait Finance House', image: require('@/assets/images/fpx/KFH0346.png') },
      { code: 'OCBCMYKL', name: 'OCBC Bank', image: require('@/assets/images/fpx/OCBC0229.png') },
      { code: 'SCBLMYKX', name: 'Standard Chartered', image: require('@/assets/images/fpx/SCB0216.png') },
      { code: 'UOVBMYKL', name: 'United Overseas Bank', image: require('@/assets/images/fpx/UOB0226.png') },
      { code: 'BPMBMYKL', name: 'Agrobank', image: require('@/assets/images/fpx/AGRO01.png') },
    ]
  }),
  computed: {
    ...mapState('user', ['member']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.agent) {
      this.bank = this.agent.bank || null
      this.bankAccounut = this.agent.bank_account || null
      this.accountName = this.agent.account_name || null
    } else  {
      this.bank = this.member.bank || null
      this.bankAccounut = this.member.bank_account || null
      this.accountName = this.member.account_name || null
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const data = {
        account_name: this.accountName,
        bank: this.bank,
        bank_account: this.bankAccounut
      }
      if (this.agent) {
        this.axios.patch(`/agent/agents/${this.agent.id}`, data)
          .then(() => {
            this.showModal = false
            this.$emit('refresh')
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.axios.patch(`/members/${this.member.id}`, data)
          .then(resp => {
            this.$store.commit('user/setMember', resp.data)
            this.showModal = false
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "bank_name": {
      "label": "Bank name",
      "placeholder": "Write your bank name here"
    },
    "account_num": {
      "label": "Account number",
      "placeholder": "Write your account number here"
    },
    "account_name": {
      "label": "Account owner",
      "placeholder": "Write account owner's name here"
    }
  },
  "id": {
    "bank_name": {
      "label": "Nama Bank",
      "placeholder": "Tulis nama bank kamu"
    },
    "account_num": {
      "label": "Nomor akun",
      "placeholder": "Tulis nomor akun"
    },
    "account_name": {
      "label": "Pemilik Akun",
      "placeholder": "Tulis nama pemilik akun di sini"
    }
  }
}
</i18n>
